export class APIResult<T> {
    constructor(source?: APIResult<unknown>) {
        if (source) {
            this.errorMessage = source.errorMessage;
            this.showError = source.showError;
            this.success = false;
        }
    }

    public success = false;

    public showError = true;

    public errorMessage = '';

    public data: T | null = null;
}
